import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "../../../../redux/store";
import { IOption, IVDMDashboardContent } from "redux/app/vdmdashboard/@types";
import CardAlertPill from "./_elements/CardAlertPill";
type OwnProps = {
	// data: ICard1Data;
	data?: IVDMDashboardContent["navigation"];
};
type Card4Props = PropsFromRedux & OwnProps;
function Card4(props: Card4Props) {
	const { data } = props;
	const info = ["Last 24hrs"];
	if (!data) return null;
	const { aftDraft, fwdDraft, heading, sog, stw } = data;
	const metricsToShow = [
		{
			label: "FWD Draft",
			value: fwdDraft ? `${fwdDraft} mtr` : undefined,
		},
		{
			label: "AFT Draft",
			value: aftDraft ? `${aftDraft} mtr` : undefined,
		},
		{
			label: "SOG",
			value: sog ? `${sog} kt` : undefined,
		},
		{
			label: "STW",
			value: stw ? `${stw} kt` : undefined,
		},
	];

	const noneOfTheValuesArePresent = metricsToShow?.every((met) => !met.value);

	if (noneOfTheValuesArePresent) {
		return (
			<div className="flex-1 hover:cursor-pointer">
				<div className="bg-gradient-to-b from-white to-[#F9FCFE] border border-gray-200 rounded-xl p-4 pr-0 shadow-sm xl:max-w-[296.5px] h-full sm:h-[179px] min-w-[176px] flex flex-col justify-between hover:shadow relative">
					<div className="flex flex-col gap-x-8 justify-between h-full">
						<div>
							<h3 className="text-xs text-gray-800 font-medium mb-1 py-1 border-l-4 border-l-[#3182CE] px-2 bg-gradient-to-r from-[#3182CE29] to-[#3182CE00] w-1/2">
								Navigation
							</h3>
							<p className="text-sm lg:text-base xl:text-lg font-medium text-gray-400 mb-3">
								No data available
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="flex-1 hover:cursor-pointer 2xl:w-full">
			<div className="bg-gradient-to-b from-white to-[#F9FCFE] border border-gray-200 rounded-xl p-4 pr-0 shadow-sm xl:max-w-[296.5px] h-full sm:h-[179px] min-w-[176px] 2xl:max-w-full flex flex-col justify-between hover:shadow relative">
				<div className="flex flex-col gap-x-8 justify-between h-full">
					<div>
						<h3 className="text-xs text-gray-800 font-medium mb-1 py-1 border-l-4 border-l-[#3182CE] px-2 bg-gradient-to-r from-[#3182CE29] to-[#3182CE00] w-1/2">
							Navigation
						</h3>
						<p className="text-sm lg:text-base xl:text-lg font-medium text-gray-800 mb-3">
							{heading}{heading && !isNaN(+heading) ? "°" : null}
						</p>
					</div>
					<div className="space-y-2 text-xs">
						<div className="flex flex-col 2xl:flex-row 2xl:flex-wrap gap-y-2 w-full">
							{metricsToShow
								?.slice(0, 4)
								.map(
									(
										metric: IOption | { label: string; value?: string },
										index: number,
									) => {
										const { label, value } = metric;
										if (typeof value !== "undefined")
											return (
												<div
													key={label + value}
													className="flex gap-2 items-center lg:w-full xl:w-3/4 2xl:w-1/2"
												>
													<span className="text-gray-500 font-medium inline-block w-[60px]">
														{label}
													</span>
													<span className="text-gray-700 font-medium">
														{value}
													</span>
												</div>
											);
										else return null;
									},
								)}
						</div>
					</div>

					<div className=" right-0 top-0 mt-2 absolute flex flex-col items-end">
						{info?.map((alert) => {
							return <CardAlertPill key={alert} alert={alert} type="info" />;
						})}
					</div>
				</div>
			</div>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(Card4);
